angular.module 'zc.projects'

.config ($stateProvider) ->

  $stateProvider
  .state 'admin.home',
    url: '/home'
    views:
      'header@':
        templateUrl: '/templates/core/views/admin_header.html'
        controller: 'AdminHeaderCtrl'
      'mainnav@':
        templateUrl: '/templates/core/views/emptynav.html'
      'content@':
        templateUrl: '/templates/projects/views/home.html'
        controllerAs: '$ctrl'
        controller: 'HomeCtrl'
    resolve:
      projects: (Project, Devise, Meta, $q, $state, $window) ->
        $q.all([
          Devise.getCurrentUser(),
          Project.all()])
        .then ([user, projects]) ->
          unless Devise.isMaster()
            lite_projects = projects.filter (project) -> project.product_line == 'zenclerk_s'
            projects = projects.filter (project) -> project.product_line != 'zenclerk_s'

          if projects.length == 1
            $state.go 'admin.projects.campaigns.list', { projectId: projects[0].id }
          else if projects.length == 0 && lite_projects?.length > 0
            Meta.getServices()
            .then (services) ->
              $window.location.href = services.zcs
          else
            projects

  .state 'admin.projects',
    abstract: true
    url: '/projects/{projectId:int}'
    views:
      'mainnav@':
        templateUrl: '/templates/core/views/mainnav.html'
        controller: 'MainnavCtrl'
    resolve:
      currentProject: (Project, Devise, Meta, $q, $stateParams, $window) ->
        $q.all([
          Devise.getCurrentUser(),
          Project.getCurrent($stateParams.projectId)])
        .then ([user, project]) ->
          if !Devise.isMaster() && project.product_line == 'zenclerk_s'
            Meta.getServices()
            .then (services) ->
              $window.location.href = services.zcs
          else
            project




  .state 'admin.projects.edit',
    url: '/edit'
    views:
      'mainnav@':
        template: ''
      'content@':
        templateUrl: '/templates/projects/views/edit.html'
        controller: 'EditProjectCtrl'

  .state 'admin.projects.detail',
    url: '/detail'
    views:
      'content@':
        templateUrl: '/templates/projects/views/detail.html'
        controller: 'DetailProjectCtrl'
        resolve:
          visitorIdsForDM: (Project, $stateParams) ->
            Project.getVisitorIdsForDM(projectId: $stateParams.projectId)

  .state 'admin.projects.analytics',
    url: '/analytics'
    views:
      'content@':
        templateUrl: '/templates/projects.analytics/views/show.html'
        controller: 'AnalyticsProjectCtrl'

  .state 'admin.projects.iw',
    abstract: true
    url: '/iw'

  .state 'admin.projects.iw.report',
    url: '/report'
    views:
      "content@":
        template: '<zc-iw-report project="$resolve.currentProject"></zc-iw-report>'

  .state 'admin.projects.iw.items',
    url: '/items'
    views:
      "content@":
        template: '<zc-iw-items project="$resolve.currentProject"></zc-iw-items>'

  .state 'admin.projects.site_report',
    abstract: true
    url: '/site_report'

  .state 'admin.projects.site_report.summary',
    url: '/summary/:month'
    views:
      "content@":
        template: '<zc-summary-site-report project="$resolve.currentProject"></zc-summary-site-report>'

  .state 'admin.projects.images',
    url: '/images'
    views:
      'content@':
        templateUrl: '/templates/projects/views/images/index.html'
        controller: 'ImagesCtrl'
        resolve:
          images: (Image, $stateParams) ->
            Image.all({projectId: $stateParams.projectId})

  .state 'admin.projects.maintenance',
    url: '/maintenance'
    views:
      'mainnav@':
        templateUrl: '/templates/projects/views/maintenance.html'
        controller: 'MainnavCtrl'
    resolve:
      currentProject: (Project, $stateParams) ->
        Project.getCurrent($stateParams.projectId)



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/routes.js.coffee